/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* This template has been built upon, with additional code and configuration by Tazi Rides Ltd.
*/

// @mui material components
import Grid from '@mui/material/Grid'

import MDBox from 'components/MDBox'
import { useMaterialUIController } from 'context'
import BaseLayout from 'layouts/account/components/BaseLayout'
import AdminUserControl from 'layouts/account/settings/components/AdminUserControl'
import Billing from 'layouts/account/settings/components/Billing'
import ChangePassword from 'layouts/account/settings/components/ChangePassword'
import Header from 'layouts/account/settings/components/Header'
import Logout from 'layouts/account/settings/components/Logout'
import TranscriptAnalysis from 'layouts/call-insights/components/TranscriptAnalysis'

function Settings(): JSX.Element {
	const [controller, _] = useMaterialUIController()
	const { session } = controller
	return (
		<BaseLayout>
			<MDBox mt={4}>
				<Grid container spacing={3}>
					<Grid item xs={12} lg={12}>
						<MDBox mb={3}>
							<Grid container spacing={3}>
								<Grid item xs={12}>
									<Header />
								</Grid>
								{session.data.role === 'ADMIN' && (
									<Grid item xs={12}>
										<AdminUserControl />
									</Grid>
								)}
								{session.data.role === 'ADMIN' && (
									<Grid item xs={12}>
										<Billing />
									</Grid>
								)}
								{session.user.email.endsWith('lexicon-labs.co.uk') && (
									<Grid item xs={12}>
										<TranscriptAnalysis />
									</Grid>
								)}
								<Grid item xs={12}>
									<ChangePassword />
								</Grid>
								<Grid item xs={12}>
									<Logout />
								</Grid>
							</Grid>
						</MDBox>
					</Grid>
				</Grid>
			</MDBox>
		</BaseLayout>
	)
}

export default Settings
